import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllError } from './error';
import { BllFormHint } from './form-hint';
import { BllFormField } from './form-field.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BllTooltipModule } from '../tooltip';
import { BllIconModule } from '../icon';

@NgModule({
  imports: [CommonModule, NgbTooltipModule, BllTooltipModule, BllIconModule],
  declarations: [BllError, BllFormHint, BllFormField],
  exports: [BllError, BllFormHint, BllFormField],
})
export class BllFormFieldModule {}
